module.exports = __webpack_public_path__ + "img/whel.846a9544.jpg";